<script lang="ts">
  import { fly, fade } from 'svelte/transition';
  import { currentTheme as theme, toggleTheme, getPalette } from '../../theme.svelte';
  import { MAIN_URL, PLANS_URL, LOGOUT_URL } from '../../externalUrls';

  let { username = 'flashclasic', avatarSrc = undefined,  palette = getPalette() } = $props();

  let open = $state(false);

  function toggleOpen() {
    open = !open;
  }

  function handleToggleTheme() {
    toggleTheme();
  }

  // Cerrar menú cuando se cambie el tema
  $effect(() => {
    theme.value;
    open = false;
  });
  // ...

  const menuItems = [
    { key: 'theme', action: 'toggleTheme' },
    { key: 'home', label: 'Pagina Principal', action: 'home' },
    { key: 'plans', label: 'Gestionar Planes', action: 'plans' },
    { key: 'logout', label: 'Cerrar Sesion', action: 'logout' }
  ] as const;

  function labelFor(item: (typeof menuItems)[number]) {
    if (item.key === 'theme') {
      return theme.value === 'light' ? 'Activar modo oscuro' : 'Activar modo claro';
    }
    return item.label;
  }

  function handleItemClick(action: string) {
    if (action === 'toggleTheme') {
      handleToggleTheme();
      return;
    }

    if (action === 'home') {
      window.location.href = MAIN_URL;
    } else if (action === 'plans') {
      window.location.href = PLANS_URL;
    } else if (action === 'logout') {
      window.location.href = LOGOUT_URL;
    }
  }
</script>

<div class="user-menu-wrapper">
  <button
    class="user-button"
    type="button"
    onclick={toggleOpen}
    style={`background-color: ${palette.bgSidebar}; color: ${palette.textPrimary}; border-color: ${palette.borderSoft};`}
  >
    {#if avatarSrc}
      <img class="avatar avatar-img" src={avatarSrc} alt={username} />
    {:else}
      <div class="avatar avatar-fallback"></div>
    {/if}
    <span class="username">{username}</span>
    <span class="chevron">{open ? '▴' : '▾'}</span>
  </button>

  {#if open}
    <div
      class="dropdown"
      style={`background-color: ${palette.userMenuBg}; border-color: ${palette.borderSoft};`}
      transition:fly={{ y: 8, duration: 150 }}
    >
      {#each menuItems as item}
        <button
          class="dropdown-item"
          type="button"
          onclick={() => handleItemClick(item.action)}
          style={`color: ${palette.textPrimary};`}
        >
          {labelFor(item)}
        </button>
      {/each}
    </div>
  {/if}
</div>

<style>
  .user-menu-wrapper {
    position: relative;
    padding: 0 12px 16px 12px;
  }

  .user-button {
    width: 100%;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    display: flex;
    align-items: center;
    padding: 8px 10px;
    cursor: pointer;
    gap: 8px;
  }

  .avatar {
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }

  .avatar-img {
    object-fit: cover;
  }

  .avatar-fallback {
    background: radial-gradient(circle at 30% 30%, #003cff, #00ccff, #ffffff);
  }

  .username {
    font-size: 13px;
    flex: 1;
    text-align: left;
  }

  .chevron {
    font-size: 10px;
  }

  .dropdown {
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 56px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    z-index: 20;
  }

  .dropdown-item {
    width: 100%;
    text-align: left;
    padding: 8px 12px;
    border: none;
    background: transparent;
    font-size: 13px;
    cursor: pointer;
  }

  .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }
</style>